export { default } from "./skeleton-image";
export * from "./types";
